import http from "./http";

// Dynamic roles CRUD.
// Returns: { status, data: [{ id, role_key, label, is_system }, ...] }
export const getRoles = async () => {
  const res = await http.get("roles");
  return res.data;
};

export const createRole = async ({ role_key, label }) => {
  const res = await http.post("roles", { role_key, label });
  return res.data;
};

export const updateRole = async ({ id, label, role_key }) => {
  const payload = { id };
  if (label !== undefined) payload.label = label;
  if (role_key !== undefined) payload.role_key = role_key;
  const res = await http.put("roles", payload);
  return res.data;
};

export const deleteRole = async (id) => {
  const res = await http.delete("roles", { data: { id } });
  return res.data;
};
